export function exportToCSV( rows,filename) {
    if (!rows || !rows.length) {
      return;
    }
  
    const separator = ',';
    const keys = Object.keys(rows[0]);
  
    // Create CSV header
    const csvContent = [
      keys.join(separator),
      ...rows.map(row => 
        keys.map(k => 
          `"${(row[k] !== null && row[k] !== undefined) ? String(row[k]).replace(/"/g, '""') : ''}"`
        ).join(separator)
      )
    ].join('\n');
  
    // Create Blob and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
  
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  